import _ from 'lodash';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import Chart from '../../util/chart';
import Api from '../../services/ApiService';
import { outputTypes } from './PrintJobUtil';

const elementId = 'printlog-chart';

const PrintLogGraph = () => {
  const showGraph = useSelector(state => _.get(state.app.userData, 'print.showGraph', true));

  useEffect(() => {
    Api.get('print/graph').then(({ data }) => {
      const dataProvider = [];
      _.each(data.results, (obj, date) => {
        dataProvider.push({ date, ...obj });
      });

      const graphBase = {
        fillAlphas: 0.6,
        lineAlpha: 0.4,
        bullet: 'round',
        lineThickness: 2,
        valueAxis: 'output-axis',
      };

      const graphs = outputTypes.map(output => {
        return {
          title: output,
          valueField: output,
          balloonText: `${output}: <b>[[value]]</b>`,
          ...graphBase,
        };
      });

      graphs.push({
        title: 'Requests',
        valueField: 'requests',
        lineThickness: 4,
        fillAlpha: 0,
        bullet: 'round',
        bulletSize: 8,
        balloonText: '[[title]]: <b>[[value]]</b>',
        valueAxis: 'requests-axis',
      });

      Chart.makeSerialChart(elementId, {
        numberFormatter: {
          precision: -1,
        },
        dataProvider,
        graphs,
        categoryField: 'date',
        categoryAxis: {
          startOnAxis: true,
          gridAlpha: 0.07,
        },
        valueAxes: [
          {
            id: 'output-axis',
            stackType: 'regular',
            title: 'Output Paths',
          },
          {
            id: 'requests-axis',
            gridAlpha: 0,
            position: 'right',
            title: 'Requests',
          },
        ],
      });
    });
  }, []);

  return <div id={elementId} style={{ height: '400px', display: showGraph ? 'block' : 'none' }} />;
};

export default PrintLogGraph;
